<template>
    <div class="locale-changer">
        <div class="toggle-locale-menu-button" @click="hidden = !hidden">
            <span class="locale-name">{{ $i18n.locale.toUpperCase() }}</span>
            <img class="locale-icon" :src="require(`@/assets/icons/locale_${$i18n.locale}.png`)" />
            <ul class="locale-list" v-if="!hidden">
                <li
                    v-for="(lang, i) in langs"
                    :key="`Lang${i}`"
                    :value="lang"
                    :class="$i18n.locale === lang ? 'active' : ''"
                    @click="setLocale(lang)"
                >
                    <img class="locale-icon" :src="require(`@/assets/icons/locale_${lang}.png`)" />
                    <span class="locale-name">{{ lang }}</span>
                </li>
            </ul>
        </div>
        <!-- <select v-model="$i18n.locale">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
        </select>-->
    </div>
</template>

<script>
export default {
    name: "locale-changer",
    data() {
        return {
            langs: ["nl", "en"],
            hidden: true
        };
    },
    methods: {
        setLocale(locale) {
            const currentRoute = this.$router.currentRoute;
            const currentRouteIdWithoutLocale = currentRoute.name.substring(3);

            this.$i18n.locale = locale;
            this.hidden = !this.hidden;

            const newRouteId = `${locale}_${currentRouteIdWithoutLocale}`;
            const routes = this.$router.options.routes[0].children;
            const localeRoutes = this.$router.options.routes.filter(r =>
                r.path.includes(locale)
            );
            if (localeRoutes.length > 0) {
                const matchingRoutes = localeRoutes[0].children.filter(
                    r => r.name === newRouteId
                );
                if (matchingRoutes.length > 0) {
                    const newRoutePath = `/${locale}/${matchingRoutes[0].path}`;
                    this.$router.push(newRoutePath);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.locale-changer {
    position: relative;
    // display: flex;
    // flex-direction: row;
    // align-items: center;

    .toggle-locale-menu-button {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        .locale-name {
            margin-right: 8px;
            font-size: 14px;
        }

        .locale-icon {
            width: 52px;
            height: 36px;
        }
    }

    ul.locale-list {
        list-style: none;
        position: absolute;
        top: calc(100% + 4px);
        right: 0;
        left: auto;

        @media screen and (max-width: 950px) {
            right: auto;
            left: 0;
        }

        border-radius: 4px;
        background-color: #fff;

        li {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;

            border-radius: 4px;

            padding: 16px 20px;
            color: black;

            cursor: pointer;
            &.active,
            &:hover {
                background-color: #f2f2f2;
            }

            .locale-name {
                margin-right: 0;
            }
            .locale-icon {
                margin-right: 8px;
            }
        }
    }
}
</style>
